// The Section edit-lock contract, shared between the API (builds these) and the
// web app (renders the lock indicator + drives acquire/heartbeat/release).
/**
 * A lock auto-expires this long after its last heartbeat. The heartbeat cadence
 * must stay well under this so an active editor is never evicted mid-edit.
 */
export const SECTION_LOCK_TTL_MS = 3 * 60 * 1000; // 3 mins
/** Cadence of the web's activity-gated heartbeat while a section is held. */
export const SECTION_LOCK_HEARTBEAT_MS = 60 * 1000; // 1 min
//# sourceMappingURL=section-lock.js.map